<template>
<el-row>
   <headertop></headertop>
   <el-row class="all">
     <el-row>
       <el-col :span="10">
         <el-row >
           <el-image  fit="scale-down" :src="con.img" @click="video_see('video',info.num)"></el-image>
         </el-row>
       </el-col>
       <el-col :span="14">
         <el-row style="padding: 0 1.25rem;">
           <el-row class="name_con">
             <span class="name_text" >{{con.name}}</span>
           </el-row>
           <el-row style="height: 1px; border-bottom: 1px dashed #999; margin-top: 0.625rem;"></el-row>
             <h3>讲师：{{con.teacher}}</h3>
             <el-button type="primary"  size="mini"  style="margin-top:20px;" @click="video_see('video',info.num)">立即播放</el-button>
           <!-- <el-row class="text_con" >
             <span @click="show('brief')">
               课程简介：{{con.brief}}
             </span>
           </el-row> -->
         </el-row>
       </el-col>
     </el-row>

     <el-row style="margin-top: 1.25rem;">
       <el-tabs type="border-card">
         <el-tab-pane label="课程详情">
           <h3 style="color: #409EFF;">
            版权归睿知而行所有，禁止录屏。本平台所有视频只针对学习者，禁止对外培训使用，禁止擅自上传到其他平台或网站，违者追究侵权责任!
          </h3>
           <el-row>
             <h3>课程简介：</h3>
             <span  v-if="con.info==0">
               暂无简介
             </span>
             <span v-html="`${con.info}`.replace(/\n/g,'<br/>')"   v-else>
             </span>
           </el-row>
         </el-tab-pane>
         <!-- <el-tab-pane label="讲师介绍">
           {{con.teacher_info}}
         </el-tab-pane> -->
         <!-- <el-tab-pane label="讲师相关课程">
           <el-row v-for="(item ,index) in recommend" :key='index'>
            <el-row style="border-bottom: 1px solid #ebebeb;padding: 1.25rem 1.25rem 0.625rem 1.25rem ;"> {{item.name}}
            <el-button style="float: right;" round size="mini" type="primary" >立即播放</el-button>
            </el-row>
           </el-row>
         </el-tab-pane> -->
         <el-tab-pane label="推荐课程"><el-row v-for="(item ,index) in con.recommend" :key='index'>
        <el-row style="border-bottom: 1px solid #ebebeb;padding: 1.25rem 1.25rem 0.625rem 1.25rem ;"> {{item.name}}
        <el-button style="float: right;" round size="mini" type="primary" @click="video_see('tuijian',item.num)" >立即播放</el-button>
        </el-row>
       </el-row></el-tab-pane>
       </el-tabs>
     </el-row>
   </el-row>
   <footerbom></footerbom>
   <el-dialog
     title="详情"
     :visible.sync="dialog.show"
      width="60%">
      <div  :style='{height:dialog.height}' class="dialog">
        <el-row>
          <h3>课程简介：</h3>
          <span v-html="con.brief"></span>
        </el-row>
        <el-row >
          <h3>课程详情：</h3>
          <span v-html="con.detailed"></span>
        </el-row>
      </div>


     <span slot="footer" class="dialog-footer">
       <el-button type="primary" @click="dialog.show = false">关 闭</el-button>
     </span>
   </el-dialog>
</el-row>
</template>


<script>
  import Header from '../../../components/index/public/NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  export default {
    name: 'App',
    data() {
      return {

        dialog:{
          show:false,
          height:document.documentElement.clientHeight * 0.5+'px'
        },
        info:{
          num:this.$route.query.num,
          type:0,
          resource:'l',
        },
        con:{},
        recommend:[]
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
    },
    mounted:function(){
      this.get_list()
    },
    methods: {
      get_list(){
        let _this=this
        // type:this.$route.query.type,
        // num:this.$route.query.num,
        // resource:this.$route.query.resource,
       _this.axios.get('/v2/user_resource/get_type_info',{params:{num:_this.info.num}}).then(function(res) {
         if(res.status=='200'){
           if(res.data.code=='1'){
             _this.con=res.data.data
           }else{
             _this.$message.error(res.data.msg)
           }
         }else{
           _this.$message.error('服务器内部错误')
         }
       }).catch(function(error) {
         _this.$message.error('服务器内部错误')
       });
      },
      video_see(type,num){
         let url=''
        if(type=='video'){
           url= this.$router.resolve({path:'/courseplay',query:{num:num,type:this.info.type,resource:this.info.resource}})
        }else{
           url= this.$router.resolve({path:'/video_info',query:{num:num}})
        }

        window.open(url.href,"_blank")
      },
      show(type){
        this.dialog.show=true
      },
  }}
</script>

<style scoped>
  .dialog{
    overflow: auto;
  }
  .text_con{
    cursor: pointer;
    margin-top:10px;
    overflow:hidden;
    text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:3;
  }
  .name_text{
        display: block;
        font-size: 1.3em;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: bold;
  }
  .name_con{
   overflow:hidden;
    text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2;
  }
.all{
  min-height: calc(100vh - 280px);
  width: 62%;
  padding: 20px;
  margin: 0 15%;
  z-index: 100;
  background-color: white;
  overflow: hidden;
}

.con{
  margin-top: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/view/index/Courses/video_info.vue